/*
// jei reikia, galime perrasyti core komponentus, pvz.
init_tooltips = function(context) {
	$('[data-toggle="tooltip"]', context).tooltip({placement:'bottom'});
}
*/

$(function () {
    init_product_slider(document);
    init_economic_slider(document);
    init_related_slider(document);
    init_duration_slider(document);
    init_career_banners_slider(document);
    init_ecomm();
    init_likes();
    init_shares();
    init_secrets();
    init_dropdown_positioning();
    init_stories();
    init_cheaper_form();
    init_career_form();
    init_form_files();
    init_mobile_menu();
    init_desktop_menu();


    $('[data-scrollto]').on('click keydown', function(e) {
        if (e.type === 'click' || (e.type === 'keydown' && (e.which === 13 || e.which === 32))) {
            e.preventDefault();


            let top_gap_size = 76;
            let element = $($(this).data('scrollto'));

            if (!element.length) return;

            if (get_vw() > screen_sm_max) {
                top_gap_size = 109;
            }

            const focusTarget = element.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
            if (focusTarget.length) focusTarget.trigger('focus');

            $('html, body').animate({scrollTop: element.offset().top - top_gap_size}, 'slow');
        }
    });

    $(document).on('keydown', 'input[type="checkbox"]', function(e) {
        if (e.which === 13 || e.which === 32) {
            e.preventDefault();

            $(this).click();
        }
    });

    $(window).scroll(init_dropdown_positioning);

    $('.duks-list .single-tab .tab-header').click(function () {
        $(this).parent().find('.tab-content').slideToggle('fast', function () {
            $(this).parent().toggleClass('active')
        });
    });
});

function init_product_slider(context) {
    $('.product-slider-container', context).addClass('owl-container');
    $('.product-slider-container .product_listing', context).each(function () {
        // Add main classes
        $(this).addClass('owl-carousel');

        // Options
        $(this).owlCarousel({
            autoHeight: true,
            loop: false,
            autoplay: false,
            //autoplayTimeout: 5000,
            //autoplayHoverPause: true,
            nav: true,
            navText: [
                "<span class='icon icon-left-big'></span>",
                "<span class='icon icon-right-big'></span>",
            ],
            responsiveClass: true,
            // navContainer: '.owl-out-nav',dddddacdscvf zxxx
            slideBy: 'page',
            dots: false,
            responsive: {
                0: {
                    items: 2
                },
                750: {
                    items: 3
                },
                970: {
                    items: 4
                },
                1170: {
                    items: 5
                }
            }
        });
    });
}

function init_related_slider(context) {
    if ($('#related-offers', context).length) {
        let related_offers = new Swiper('#related-offers .swiper-related', {
            slidesPerView: "1.3",
            spaceBetween: 16,
            scrollbar: {
                el: '#related-offers .swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                550: {
                    slidesPerView: '1.8'
                },
                768: {
                    slidesPerView: '2.3'
                },
                992: {
                    slidesPerView: '4'
                }
            }
        });
    }
}

function init_duration_slider(context) {
    if ($('.custom-swiper-wrp', context).length) {
        $('.custom-swiper-wrp', context).each(function () {
            let id = $(this).data('id');
            let container = document.querySelector('.custom-swiper-wrp[data-id="'+ id +'"]');
            let item = container.querySelector(".custom-swiper-item");
            let itemWidth = item.offsetWidth;

            container.parentNode.querySelector(".swiper-button-prev").addEventListener("click", function() {
                container.scrollBy({ left: -itemWidth, behavior: "smooth" });
            });
            container.parentNode.querySelector(".swiper-button-next").addEventListener("click", function() {
                container.scrollBy({ left: itemWidth, behavior: "smooth" });
            });

            container.addEventListener('scroll', (event) => {
                if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
                    container.parentNode.querySelector('.swiper-button-next').classList.add('swiper-button-disabled');
                } else if (container.scrollLeft == 0) {
                    container.parentNode.querySelector('.swiper-button-prev').classList.add('swiper-button-disabled');
                } else {
                    container.parentNode.querySelectorAll('.swiper-button').forEach(function(nav) {
                        nav.classList.remove('swiper-button-disabled');
                    });
                }
            });

            update_nav(container);
            window.addEventListener('resize', (event) => {
                update_nav(container);
            });

            function update_nav(element) {
                var display = 'none';

                if (element.clientWidth < element.scrollWidth) {
                    display = 'flex';
                }
                element.parentNode.querySelectorAll('.swiper-button').forEach(function(btn) {
                    btn.style.display = display;
                    btn.classList.remove('swiper-button-disabled')
                });

                element.dispatchEvent(new Event('scroll'));
            }
        });
    }
}

function init_economic_slider(context) {
    if ($('#economic-offers', context).length) {
        let economic_offers = new Swiper('#economic-offers .swiper-economic', {
            slidesPerView: "1.3",
            spaceBetween: 16,
            scrollbar: {
                el: '#economic-offers .swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                550: {
                    slidesPerView: '1.8'
                },
                768: {
                    slidesPerView: '2.3'
                },
                992: {
                    slidesPerView: '4'
                }
            }
        });
    }
}

function init_career_banners_slider(context) {
    if ($('.career-banners-swiper', context).length) {
        $('.career-banners-swiper', context).each(function () {
            let id = $(this).data('id');

            let career_banners = new Swiper('.career-banners-swiper[data-id="'+ id +'"]', {
                slidesPerView: 1,
                spaceBetween: 32,
                loop: true,
                centeredSlides: true,
                navigation: {
                    nextEl: '.career-banners-swiper[data-id="'+ id +'"] .swiper-button-next',
                    prevEl: '.career-banners-swiper[data-id="'+ id +'"] .swiper-button-prev',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1.5,
                    }
                }
            });
        });
    }
}

function init_likes() {
    $('.like-act').each(function () {
        var exists = localStorage.getItem('fav-' + $(this).data('id'));
        if (exists === '1') {
            $(this).addClass('active');
            $(this).find('span').html($(this).data('likes') + 1);
        }
    });
    $('.like-act').click(function (e) {
        e.preventDefault();
        var exists = localStorage.getItem('fav-' + $(this).data('id'));
        if (exists === '1') {
            localStorage.removeItem('fav-' + $(this).data('id'));
            $(this).removeClass('active');
            $(this).find('span').html($(this).data('likes'));
        } else {
            localStorage.setItem('fav-' + $(this).data('id'), '1');
            $(this).addClass('active');
            $(this).find('span').html($(this).data('likes') + 1);
        }
    });
}

function init_shares() {
    $('.share-act').click(function (e) {
        e.preventDefault();
        if (navigator.share) {
            navigator.share({
                title: $(this).data('title'),
                url: $(this).data('url')
            });
        } else {
            if (!$("link[href='https://use.fontawesome.com/releases/v5.8.1/css/all.css']").length) {
                var head = document.getElementsByTagName('HEAD')[0];
                var link = document.createElement('link');
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = 'https://use.fontawesome.com/releases/v5.8.1/css/all.css';
                head.appendChild(link);
            }

            var title = encodeURIComponent($(this).data('title'));
            var url = encodeURIComponent($(this).data('url'));
            $('#shareModal').modal('show');
            $('#shareModal .modal-body a ').each(function () {
                if ($(this).data('share')) {
                    var href = $(this).data('share').replace('<title>', title).replace('<url>', url);
                    $(this).attr('href', href);
                }
            });
        }
    });
}

function init_secrets() {
    window.check_secrets = function (first_time = false) {
        $('.secret-offer').each(function () {
            var exists = localStorage.getItem('secret-' + $(this).data('id'));
            if (exists === '1') {
                $(this).find('.secret-overlay').removeClass('d-flex').hide();
                $(this).find('.secret-hidden').removeClass('d-none');
                $(this).removeClass('secret-offer');
            }
        });
        if (!first_time) {
            //trigger date
            if (window.search_air) {
                window.search_air._date_input_format();
                window.search_air.filterDateAndRange();
                window.search_air.month_checker();
            }
            //trigger duration
            if (window.search_duration_air) {
                window.search_duration_air._check_days();
                window.search_duration_air._check_increments();
                window.search_duration_air._input_format();
            }
            //trigger destination
            $('.destination-select .category-group > .single-category').each(function () {
                if ($(this).hasClass('active')) {
                    add_destination_bubble($(this).data('ftype'), $(this).data('fvalue'), $(this).data('fname'));

                    $(this).parent().find('.submenu_list > .single-category.active').each(function () {
                        window.customFilters.addValue($(this).data('ftype'), $(this).data('fvalue'));

                        if ($(this).data('fname') !== '') {
                            window.customFilters.addName($(this).data('ftype'), $(this).data('fname'));
                        }
                    });
                } else {
                    let active2 = false;

                    $(this).parent().find('.submenu_list > .single-category.active').each(function () {
                        active2 = true;
                        add_destination_bubble($(this).data('ftype'), $(this).data('fvalue'), $(this).data('fname'));

                        window.customFilters.addValue($(this).data('ftype'), $(this).data('fvalue'));
                        if ($(this).data('fname') !== '') {
                            window.customFilters.addName($(this).data('ftype'), $(this).data('fname'));
                        }
                    });

                    if (active2) {
                        $(this).parent().addClass('open');
                    }
                }
            });
            update_destination_btn_text();
        }
    }

    window.check_secrets(true);

    $(document).on('click', '.secret-offer', function (e) {
        e.preventDefault();
        localStorage.setItem('secret-' + $(this).data('id'), '1');
        var ele = $(this);
        $(this).find('.lock').removeClass('justify-content-center').addClass('justify-content-end pr-3')
        $(this).find('.lock').animate({
            width: $(this).find('.lock-background').width() + parseInt($(this).find('.lock-background').css('padding-right')) - parseInt($(this).find('.lock-background').css('padding-left'))
        }, 500, function() {
            ele.find('.secret-overlay').removeClass('d-flex').hide();
            ele.find('.secret-hidden').removeClass('d-none');
            ele.removeClass('secret-offer');
        });
    });
}

function init_ecomm() {
    window.sendPendingImpressions = function() {
        setTimeout(function() {
            if (window.pendingImpressions.length > 0) {
                var impressionsToSend = window.pendingImpressions;
                window.pendingImpressions = [];
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    'event': 'productImpressions',
                    'ecommerce': {
                        'impressions': impressionsToSend
                    }
                });
            }
            window.sendPendingImpressions();
        }, 1000);
    }
    window.sendPendingImpressions();
    $(document).on('click', '.single-offer', function(e) {
        var ele = $(this);

        // ga old
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'productClick',
            'ecommerce': {
                'detail': {
                    'products': [{
                        'name': ele.data('name'),
                        'id': ele.data('id'),
                        'price': ele.data('price')
                    }]
                }
            },
        });

        // ga4
        let ge_el = ele.parents('.product_element_wrapper');
        let promotion = ge_el.data('promotion');
        window.dataLayer.push({ ecommerce: null });
        if (promotion == true) {
            window.dataLayer.push({
                event: "select_promotion",
                ecommerce: {
                    creative_name: ge_el.data('direction'),
                    creative_slot: ge_el.data('url'),
                    promotion_id: ge_el.data('direction') + Math.ceil(ge_el.data('price')),
                    promotion_name: ge_el.data('direction') + ' ' + Math.ceil(ge_el.data('price')) + ' ' + ge_el.data('currency'),
                    items: [
                        {
                            item_id: ge_el.data('item-id'),
                            item_name: ge_el.data('name'),
                            discount: ge_el.data('item-discount'),
                            item_category: ge_el.data('category'),
                            item_variant: ge_el.data('item-variant'),
                            price: ge_el.data('price'),
                            quantity: 1
                        }
                    ]
                }
            });
        } else {
            window.dataLayer.push({
                event: "select_item",
                ecommerce: {
                    item_list_id: ge_el.data('list-id'),
                    item_list_name: ge_el.data('list-name'),
                    items: [
                        {
                            item_id: ge_el.data('item-id'),
                            item_name: ge_el.data('name'),
                            discount: ge_el.data('item-discount'),
                            item_category: ge_el.data('category'),
                            item_variant: ge_el.data('item-variant'),
                            price: ge_el.data('price'),
                            quantity: 1
                        }
                    ]
                }
            });
        }
    });
    $(document).on('submit', '.single-booking-form', function(e) {
        var ele = $(this);
        var btn_ele = $(this).find('.order-btn');
        btn_ele.attr('disabled','disabled').val(btn_ele.data('active-title'));

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'add': {
                    'products': [{
                        'name': window.productData.name,
                        'id': window.productData.id,
                        'price': ele.data('price'),
                        'destination': window.productData.destination,
                        'month': window.productData.month,
                        'quantity': 1
                    }]
                }
            },
        });
    });

    $(document).on(
        'keydown',
        '.single-booking-form .offer-info .info-included, .single-booking-form .offer-info .info-terms, ' +
        '.single-booking-form .actions-wrp .price-alert-btn',
        function(e) {
            if (e.which === 13 || e.which === 32) {
                e.preventDefault();
                $(this).click();
            }
        }
    );

    $(document).on('submit', '#cart_additional, #cart_additional_mob', function(e) {
        if (window.form_submitted) {
            return false;
        } else {
            window.form_submitted = true;
            var btn_ele = $('#cart_additional, #cart_additional_mob').find('.btn-step-additional');
            $('#cart_additional, #cart_additional_mob').find('.btn-step-additional').each(function(e) {
                $(this).attr('disabled','disabled').html(btn_ele.data('active-title'));
            });
            return true;
        }
    });

    $(document).on('submit', '#cart_confirm', function(e) {
        if (window.form_submitted) {
            return false;
        } else {
            window.form_submitted = true;
            var btn_ele = $('#cart_confirm').find('#desktop-pay-btn');
            $('#cart_confirm').find('#desktop-pay-btn, #mobile-pay-btn, #pay-reservation-btn').each(function(e) {
                if($(this).attr('id') == 'pay-reservation-btn') {
                    $(this).attr('disabled','disabled');
                } else {
                    $(this).attr('disabled','disabled');
                    if($('#reservation-status').val() == 0) {
                        $(this).val(btn_ele.data('active-title'))
                    }
                }
            });
            return true;
        }
    });

    $(document).on('click', '#pay-reservation-btn', function() {
        $('#reservation-status').val(1);
        $(this).text($(this).data('active-title'));
        $('#cart_confirm').find('#desktop-pay-btn, #mobile-pay-btn, #pay-reservation-btn').each(function(e) {
            $(this).attr('disabled','disabled');
        });

        $('#cart_confirm').submit();
    });
}

function init_dropdown_positioning() {
    let referenceEl = document.getElementById('departure-filter');
    let floatingEl = document.getElementById('departure-filter-dropdown');
    floating_dropdown(referenceEl, floatingEl);

    let referenceEl2 = document.querySelector('.destination-select-wrp');
    let floatingEl2 = document.querySelector('.destination-select');
    floating_dropdown(referenceEl2, floatingEl2);

    let referenceEl3 = document.querySelector('.search-body #air_date_from');
    let floatingEl3 = document.querySelector('.search-body .datepicker_air_div .datepicker_air');
    floating_dropdown(referenceEl3, floatingEl3);

    let referenceEl4 = document.querySelector('#departure-filter-wrp #departureFilterBtn');
    let floatingEl4 = document.querySelector('#departure-filter-wrp #departureFilter');
    floating_dropdown(referenceEl4, floatingEl4);
}

function init_stories() {
    if ($('.stories-container').length > 0) {
        const storyViewer = document.getElementById("storyViewer");
        const storyUser = document.getElementById("storyUser");
        const storyUserName = storyUser.querySelector('.user-name');
        const storyUserThumb = storyUser.querySelector('.user-thumb');

        let currentAuthorThumb = null;
        let currentStoryIndex = 0;
        let currentStories = [];

        let currentProgress = 0; // 0–100
        let totalDuration = 5000; // ms
        let progressInterval = null;
        let autoAdvanceTimeout = null;
        let isPaused = false;
        let currentMedia = null;

        let startTimestamp = null;
        let elapsedBeforePause = 0;

        document.querySelectorAll(".story-author-el").forEach(thumb => {
            thumb.addEventListener("click", () => {
                currentAuthorThumb = thumb;
                const user = thumb.getAttribute("data-user");
                const userThumb = thumb.getAttribute("data-thumb");
                storyUserName.textContent = user;
                storyUserThumb.src = userThumb;
                currentStories = JSON.parse(thumb.getAttribute("data-stories"));
                currentStoryIndex = 0;
                buildProgressSegments(currentStories.length);
                showViewer();
                showStory();
            });
        });

        function showViewer() {
            storyViewer.style.display = "grid";
        }

        function closeViewer() {
            storyViewer.style.display = "none";

            // Clear timers
            clearInterval(progressInterval);
            clearTimeout(autoAdvanceTimeout);
            cancelAnimationFrame(progressInterval);
            progressInterval = null;
            autoAdvanceTimeout = null;

            // Stop video if present
            if (currentMedia && currentMedia.tagName === "VIDEO") {
                currentMedia.pause();
                currentMedia.src = ""; // unload video
            }

            // Remove current media element from viewer
            const existing = document.querySelector("#storyViewer .story-img");
            if (existing) existing.remove();

            // Reset state
            currentStoryIndex = 0;
            currentStories = [];
            currentProgress = 0;
            isPaused = false;
            elapsedBeforePause = 0;
            currentMedia = null;

            // Clear progress UI
            const segments = document.querySelectorAll(".progress-fill");
            segments.forEach(seg => seg.style.width = "0%");
        }

        function showStory() {
            resetProgress();
            currentProgress = 0;
            elapsedBeforePause = 0;
            isPaused = false;
            document.getElementById("playPauseBtn").classList.add("playing");

            const story = currentStories[currentStoryIndex];
            const viewer = document.getElementById("storyViewer");

            const oldMedia = document.querySelector("#storyViewer .story-viewer-inner .story-img");

            const newMedia = document.createElement(story.type === "video" ? "video" : "img");
            newMedia.src = story.src;
            newMedia.className = "story-img";
            newMedia.id = "storyImage";
            newMedia.style.zIndex = 2;
            currentMedia = newMedia;

            const shouldFade = !(currentStoryIndex === 0 && oldMedia == null);

            function handleLoaded() {
                if (shouldFade) {
                    viewer.querySelector('.story-viewer-inner').appendChild(newMedia);
                    requestAnimationFrame(() => {
                        newMedia.classList.add("visible");
                        if (oldMedia) oldMedia.classList.remove("visible");
                    });

                    // Remove old media after fade
                    setTimeout(() => {
                        if (oldMedia && oldMedia.parentNode) {
                            oldMedia.remove();
                        }
                    }, 500);
                } else {
                    if (oldMedia) oldMedia.remove();
                    viewer.querySelector('.story-viewer-inner').appendChild(newMedia);
                    newMedia.classList.add("visible");
                }

                if (!isPaused) {
                    const duration = story.type === "video" ? newMedia.duration * 1000 : 5000;
                    startProgress(duration);
                }
            }

            if (story.type === "video") {
                newMedia.autoplay = true;
                newMedia.muted = false;
                newMedia.playsInline = true;
                newMedia.controls = false;

                newMedia.onloadedmetadata = () => {
                    handleLoaded();
                    newMedia.play().catch(err => {
                        console.log("Autoplay failed: ", err);
                    });
                };
            } else {
                newMedia.onload = handleLoaded;
            }

            // Reset progress bar visually
            setSegmentProgress(currentStoryIndex, 0);
            updateNavigationButtons();
        }


        function nextStory() {
            setSegmentProgress(currentStoryIndex, 100); // force fill

            if (currentStoryIndex < currentStories.length - 1) {
                currentStoryIndex++;
                showStory();
            } else {
                // Try moving to the next author
                const allAuthors = Array.from(document.querySelectorAll(".story-author-el"));
                const currentAuthorIndex = allAuthors.indexOf(currentAuthorThumb);

                if (currentAuthorIndex < allAuthors.length - 1) {
                    currentAuthorThumb = allAuthors[currentAuthorIndex + 1];
                    const user = currentAuthorThumb.getAttribute("data-user");
                    const userThumb = currentAuthorThumb.getAttribute("data-thumb");
                    storyUserName.textContent = user;
                    storyUserThumb.src = userThumb;

                    currentStories = JSON.parse(currentAuthorThumb.getAttribute("data-stories"));
                    currentStoryIndex = 0;
                    buildProgressSegments(currentStories.length);
                    showStory();
                } else {
                    closeViewer(); // Last author's last story
                }
            }
        }


        function prevStory() {
            const allAuthors = Array.from(document.querySelectorAll(".story-author-el"));
            const currentAuthorIndex = allAuthors.indexOf(currentAuthorThumb);

            if (currentStoryIndex > 0) {
                // If we're not at the first story of the author, move to previous story
                setSegmentProgress(currentStoryIndex, 0);
                currentStoryIndex--;
                setSegmentProgress(currentStoryIndex, 0);
                showStory();
            } else if (currentAuthorIndex > 0) {
                currentAuthorThumb = allAuthors[currentAuthorIndex - 1];
                currentStories = JSON.parse(currentAuthorThumb.getAttribute("data-stories"));
                currentStoryIndex = currentStories.length - 1;
                storyUserName.textContent = currentAuthorThumb.getAttribute("data-user");
                storyUserThumb.src = currentAuthorThumb.getAttribute("data-thumb");
                buildProgressSegments(currentStories.length);
                showStory();
            }
        }


        function buildProgressSegments(count) {
            const container = document.getElementById("progressContainer");
            container.innerHTML = "";

            for (let i = 0; i < count; i++) {
                const segment = document.createElement("div");
                segment.className = "progress-segment";

                const fill = document.createElement("div");
                fill.className = "progress-fill";
                segment.appendChild(fill);

                container.appendChild(segment);
            }
        }

        function resetProgress() {
            cancelAnimationFrame(progressInterval);
            clearTimeout(autoAdvanceTimeout);
            progressInterval = null;
            autoAdvanceTimeout = null;
        }

        function setSegmentProgress(index, percent) {
            const segments = document.querySelectorAll(".progress-fill");
            if (segments[index]) {
                segments[index].style.width = `${percent}%`;
            }
        }

        function startProgress(duration = 5000) {
            resetProgress();
            totalDuration = duration;

            const segments = document.querySelectorAll(".progress-fill");
            const current = segments[currentStoryIndex];

            startTimestamp = performance.now() - elapsedBeforePause;

            function update() {
                if (isPaused) return;

                const elapsed = performance.now() - startTimestamp;
                currentProgress = Math.min((elapsed / duration) * 100, 100);
                current.style.width = `${currentProgress}%`;

                if (currentProgress < 100) {
                    progressInterval = requestAnimationFrame(update);
                } else {
                    currentProgress = 0;
                    elapsedBeforePause = 0;
                    nextStory();
                }
            }

            update();

            autoAdvanceTimeout = setTimeout(() => {
                currentProgress = 0;
                elapsedBeforePause = 0;
                nextStory();
            }, duration - elapsedBeforePause);
        }

        function updateNavigationButtons() {
            const allAuthors = Array.from(document.querySelectorAll(".story-author-el"));
            const currentAuthorIndex = allAuthors.indexOf(currentAuthorThumb);

            const isFirstAuthor = currentAuthorIndex === 0;
            const isLastAuthor = currentAuthorIndex === allAuthors.length - 1;
            const isFirstStory = currentStoryIndex === 0;
            const isLastStory = currentStoryIndex === currentStories.length - 1;

            const prevBtn = document.getElementById("prevBtn");
            const nextBtn = document.getElementById("nextBtn");

            // Disable previous button if first story of first author
            const disablePrev = (isFirstAuthor && isFirstStory);
            const disableNext = isLastAuthor && isLastStory;

            if (disablePrev) {
                prevBtn.classList.add("disabled");
            } else {
                prevBtn.classList.remove("disabled");
            }

            if (disableNext) {
                nextBtn.classList.add("disabled");
            } else {
                nextBtn.classList.remove("disabled");
            }
        }


        // Navigation
        document.getElementById("nextBtn").onclick = nextStory;
        document.getElementById("prevBtn").onclick = prevStory;
        document.querySelectorAll(".stories-close-btn").forEach(function(close_button) {
            close_button.addEventListener('click', function (event) {
                closeViewer();
            });
        });

        // Play/Pause
        document.getElementById("playPauseBtn").onclick = function () {
            isPaused = !isPaused;

            if (isPaused) {
                this.classList.remove("playing");
                elapsedBeforePause = performance.now() - startTimestamp;
                cancelAnimationFrame(progressInterval);
                clearTimeout(autoAdvanceTimeout);
                if (currentMedia && currentMedia.tagName === "VIDEO") {
                    currentMedia.pause();
                }
            } else {
                this.classList.add("playing");
                if (currentMedia && currentMedia.tagName === "VIDEO") {
                    currentMedia.play();
                    startProgress(currentMedia.duration * 1000);
                } else {
                    startProgress(totalDuration);
                }
            }
        };
    }
}

function init_cheaper_form() {
    document.querySelectorAll(".cheaper-application-form").forEach(function(form) {
        form.addEventListener("submit", (e) => {
            e.preventDefault();

            $('#ajax_loader').show();
            const simple_fields = ['firstname', 'lastname', 'email', 'phone', 'cheaper_link', 'additional_info'];
            const formData = new FormData(form);
            var action_url = '?display=content_types/cheaper_inquiries/form';

            form.querySelectorAll('.form-error').forEach(el => el.textContent = '');
            simple_fields.forEach(field => {
                let field_el = form.querySelector(`[name="${field}"]`);
                if (field_el) {
                    field_el.classList.remove('is-invalid');
                }
            });
            form.querySelector('.main-error').classList.add('d-none');

            fetch(action_url, {
                method: 'POST',
                body: formData,
            })
            .then(res => res.json())
            .then(data => {
                $('#ajax_loader').hide();
                if (data.success) {
                    const successBlock = form.querySelector('.application-success');
                    const successCloseBtn = form.querySelector('.success-close-btn');
                    form.reset();

                    successBlock.style.display = 'flex';
                    successBlock.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });

                    successCloseBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        successBlock.style.display = 'none';
                    });
                } else if (data.errors) {
                    for (const [field, message] of Object.entries(data.errors)) {
                        const errorEl = form.querySelector(`.form-error[data-error-for="${field}"]`);
                        if (errorEl) {
                            if (simple_fields.includes(field)) {
                                form.querySelector(`[name="${field}"]`).classList.add('is-invalid');
                            }

                            errorEl.textContent = message;
                        }

                        if (field == 'main') {
                            form.querySelector(`.main-error`).textContent = message;
                            form.querySelector('.main-error').classList.remove('d-none');
                        }
                    }
                }
            })
            .catch(err => {
                $('#ajax_loader').hide();
                alert('Įvyko klaida siunčiant formą.');
            });
        });
    });
}

function init_career_form() {
    document.querySelectorAll(".application-form").forEach(function(form) {
        form.addEventListener("submit", (e) => {
            e.preventDefault();

            $('#ajax_loader').show();
            const simple_fields = ['firstname', 'lastname', 'email', 'phone', 'message'];
            const formData = new FormData(form);
            const source = formData.get('source');
            var action_url = '?display=content_types/career_positions/detailed';
            if (source && source == 'listing') {
                action_url = '?display=content_types/career_positions/listing';
            }

            form.querySelectorAll('.form-error').forEach(el => el.textContent = '');
            simple_fields.forEach(field => {
                let field_el = form.querySelector(`[name="${field}"]`);
                if (field_el) {
                    field_el.classList.remove('is-invalid');
                }
            });
            form.querySelector('.upload-box').classList.remove('is-invalid');
            form.querySelector('.main-error').classList.add('d-none');

            fetch(action_url, {
                method: 'POST',
                body: formData,
            })
            .then(res => res.json())
            .then(data => {
                $('#ajax_loader').hide();
                if (data.success) {
                    const successBlock = form.querySelector('.application-success');
                    const successCloseBtn = form.querySelector('.success-close-btn');
                    form.reset();

                    successBlock.style.display = 'flex';
                    successBlock.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                    const filePreview = form.querySelector('.uploaded-file');
                    if (filePreview) filePreview.style.display = 'none';

                    successCloseBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        successBlock.style.display = 'none';
                    });
                } else if (data.errors) {
                    for (const [field, message] of Object.entries(data.errors)) {
                        const errorEl = form.querySelector(`.form-error[data-error-for="${field}"]`);
                        if (errorEl) {
                            if (simple_fields.includes(field)) {
                                form.querySelector(`[name="${field}"]`).classList.add('is-invalid');
                            } else if (field == 'file-input') {
                                form.querySelector('.upload-box').classList.add('is-invalid');
                            }

                            errorEl.textContent = message;
                        }

                        if (field == 'main') {
                            form.querySelector(`.main-error`).textContent = message;
                            form.querySelector('.main-error').classList.remove('d-none');
                        }
                    }
                }
            })
            .catch(err => {
                $('#ajax_loader').hide();
                alert('Įvyko klaida siunčiant formą.');
            });
        })
    });
}

function init_form_files() {
    const form_files = document.querySelectorAll(".form-file");
    form_files.forEach((file) => {
        const dropArea = file.querySelector(".upload-box");
        const input = file.querySelector("input[name='file-input']");
        const preview = file.querySelector('.uploaded-file');
        const fileName = file.querySelector('.file-name');
        const fileDate = file.querySelector('.file-date');
        const deleteBtn = file.querySelector('.delete-btn');

        function handleFile(file) {
            const name = file.name;
            const size = formatSize(file.size);
            const date = new Date(file.lastModified).toISOString().slice(0, 16).replace('T', ' ');

            fileName.textContent = `${name} (${size})`;
            fileDate.textContent = date;
            preview.style.display = 'block';
        }

        function handleFileInput(file) {
            if (!isValidFile(file)) {
                alert('Tik PDF, JPG arba PNG failai yra leidžiami.');
                input.value = '';
                return;
            }

            handleFile(file);
        }

        input.addEventListener('change', (e) => {
            if (e.target.files.length) {
                handleFileInput(e.target.files[0]);
            }
        });

        dropArea.addEventListener('dragover', (e) => {
            e.preventDefault();
            dropArea.classList.add('dragover');
        });

        dropArea.addEventListener('dragleave', () => {
            dropArea.classList.remove('dragover');
        });

        dropArea.addEventListener('drop', (e) => {
            e.preventDefault();
            dropArea.classList.remove('dragover');
            const file = e.dataTransfer.files[0];
            if (file) {
                input.files = e.dataTransfer.files;
                handleFileInput(file);
            }
        });

        deleteBtn.addEventListener('click', (e) => {
            e.preventDefault();
            input.value = '';
            preview.style.display = 'none';
        });
    })

    function formatSize(bytes) {
        const kb = bytes / 1024;
        return `${kb.toFixed(1).replace('.', ',')} Kb`;
    }

    function isValidFile(file) {
        const validTypes = ['application/pdf', 'image/jpeg', 'image/png'];
        return validTypes.includes(file.type);
    }
}

function init_mobile_menu() {
    let lastSubmenuOpen = null;
    let currentTrapHandler = null;

    // menu open/close
    const burger = document.getElementById('burger-icon');
    burger.addEventListener('click', toggleMenu);
    burger.addEventListener('keydown', toggleMenu);

    function toggleMenu(e) {
        if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))) {
            e.preventDefault();
            const isOpen = document.body.classList.contains('main-nav-active');
            isOpen ? closeNav() : openNav();

            updateMobileNavFocus();
        }
    }
    function openNav() {
        document.body.classList.add('main-nav-active');
        document.querySelector('nav').classList.add('nav-mobile');
    }
    function closeNav() {
        document.body.classList.remove('main-nav-active');
        document.querySelector('nav').classList.remove('nav-mobile');

        const openPanels = document.querySelectorAll('.drawer-menu-panel.open, .mega-menu-panel.open, .list-menu-panel.open');
        openPanels.forEach(panel => {
            panel.classList.remove('open');
            panel.setAttribute('aria-hidden', 'true');
        });

        lastSubmenuOpen = null;

        if (currentTrapHandler) {
            document.removeEventListener('keydown', currentTrapHandler);
            currentTrapHandler = null;
        }
    }

    const submenuOpenTriggers = document.querySelectorAll('#pages_mega_menu .act-expand-submenu');
    const submenuCloseTriggers = document.querySelectorAll('#pages_mega_menu .panel-back-link');
    submenuOpenTriggers.forEach(submenuOpenTrigger => {
        submenuOpenTrigger.addEventListener('click', (e) => {
            toggleSubmenu(submenuOpenTrigger);
        })
        submenuOpenTrigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleSubmenu(submenuOpenTrigger);
            }
        })
    });

    submenuCloseTriggers.forEach(submenuCloseTrigger => {
        submenuCloseTrigger.addEventListener('click', (e) => {
            closePanel(submenuCloseTrigger);
        });
        submenuCloseTrigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                closePanel(submenuCloseTrigger);
            }
        })
    })

    function toggleSubmenu(element) {
        let elTarget = element.dataset.target;
        let submenu = document.getElementById(elTarget);
        let submenuOpen = submenu.classList.contains('open');

        if (submenuOpen) {
            submenu.setAttribute('aria-hidden', 'true');
            submenu.classList.remove('open');
            lastSubmenuOpen = null; // this is because drawer panel return has different close function
        } else {
            submenu.removeAttribute('aria-hidden');
            submenu.classList.add('open');

            if (element.classList.contains('drawer-menu-item') || element.classList.contains('panel-item')) {
                lastSubmenuOpen = elTarget;
                const focusTarget = submenu.querySelector('.panel-back-link[data-target="'+ elTarget +'"]');
                focusTarget?.focus();
            }
        }

        updateMobileNavFocus();
    }
    function closePanel(element) {
        let elTarget = element.dataset.target;
        let elParent = element.dataset.parent ?? null;
        let submenu = document.getElementById(elTarget);

        submenu.classList.remove('open');
        submenu.setAttribute('aria-hidden', 'true');

        if (submenu.contains(document.activeElement)) {
            const fallback = document.querySelector('.drawer-menu-item[data-target="'+ elTarget +'"]');
            const fallback2 = document.querySelector('.panel-item.has-childs[data-target="'+ elTarget +'"]');

            fallback?.focus();
            fallback2?.focus();
        }

        if (elParent) {
            lastSubmenuOpen = elParent;
        } else {
            lastSubmenuOpen = null;
        }

        updateMobileNavFocus();
    }

    function updateMobileNavFocus() {
        if (currentTrapHandler) {
            document.removeEventListener('keydown', currentTrapHandler);
            currentTrapHandler = null;
        }

        const header = document.querySelector('header');
        const menu = lastSubmenuOpen
            ? document.getElementById(lastSubmenuOpen)
            : document.getElementById('pages_mega_menu');

        if (!header || !menu) return;

        const selector = 'a[href], button, textarea, input, select, [tabindex]';
        const isFocusable = el =>
            !el.disabled &&
            el.tabIndex >= 0 &&
            el.offsetParent !== null &&
            !el.closest('[aria-hidden="true"]');

        const headerEls = [...header.querySelectorAll(selector)].filter(isFocusable);
        const menuEls = [...menu.querySelectorAll(selector)].filter(isFocusable);

        if (headerEls.length === 0 || menuEls.length === 0) return;

        const firstHeader = headerEls[0];
        const lastHeader = headerEls[headerEls.length - 1];
        const firstMenu = menuEls[0];
        const lastMenu = menuEls[menuEls.length - 1];

        currentTrapHandler = function (e) {
            if (e.key !== 'Tab') return;

            const active = document.activeElement;

            if (e.shiftKey) {
                // Shift + Tab cases
                if (active === firstMenu) {
                    e.preventDefault();
                    lastHeader.focus();
                } else if (active === firstHeader) {
                    e.preventDefault();
                    lastMenu.focus();
                }
            } else {
                // Tab cases
                if (active === lastMenu) {
                    e.preventDefault();
                    firstHeader.focus();
                } else if (active === lastHeader) {
                    e.preventDefault();
                    firstMenu.focus();
                }
            }
        };

        document.addEventListener('keydown', currentTrapHandler);
    }

    function updateNavMobilePosition(force = false) {
        let body = document.body;
        let header = document.querySelector('header');
        let navMobile = document.querySelector('nav.nav-mobile');
        let drawerPanels = document.querySelectorAll('nav.nav-mobile .drawer-menu-panel');

        if (!body || !navMobile || !header) return;

        let bodyMarginTop = parseFloat(getComputedStyle(body).marginTop) || 0;

        if (!force && lastBodyMarginTop === bodyMarginTop) return; // No change
        lastBodyMarginTop = bodyMarginTop;

        let headerHeight = header.offsetHeight;
        let totalOffset = headerHeight + bodyMarginTop;

        let heightValue = CSS.supports('height', '100dvh') ? '100dvh' : '100vh';
        navMobile.style.top = totalOffset + 'px';
        navMobile.style.height = 'calc('+ heightValue +' - '+ totalOffset +'px)';

        if (drawerPanels) {
            drawerPanels.forEach(panel => {
                panel.style.top = totalOffset +'px';
            });
        }
    }
    updateNavMobilePosition(true);
    window.addEventListener('resize', () => {
        updateNavMobilePosition(true);

        if (get_vw() > screen_sm_max) {
            closeNav();
        }
    });
    setInterval(updateNavMobilePosition, 200);
}

function init_desktop_menu() {
    const dropdownItems = document.querySelectorAll('.has-menu-dropdown');
    let hoverTimeout = null;
    let currentOpenItem = null;

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
            if (currentOpenItem !== null && currentOpenItem.classList.contains('drawer-element')) {
                if (currentOpenItem.querySelector('.menu-panel[aria-hidden="false"]')) {
                    return;
                }
            }

            dropdownItems.forEach(item => {
                item.classList.remove('show');
            });
            currentOpenItem = null;
            clearTimeout(hoverTimeout);
        }
    });

    dropdownItems.forEach(item => {
        const dropdown = item.querySelector('.menu-dropdown');
        const dropdown_expand_btn = item.querySelector('.expand-btn');

        const show = () => {
            clearTimeout(hoverTimeout);

            // Close currently open dropdown
            if (currentOpenItem && currentOpenItem !== item) {
                currentOpenItem.classList.remove('show');
            }

            item.classList.add('show');
            currentOpenItem = item;

            const dropdown = item.querySelector('.menu-dropdown');
            if (dropdown) {
                dropdown.classList.remove('align-right');

                const rect = dropdown.getBoundingClientRect();
                const rightOverflow = rect.right > window.innerWidth;
                const spaceBelow = window.innerHeight - rect.top - 20; // 20px bottom padding

                if (rightOverflow) {
                    dropdown.classList.add('align-right');
                }

                dropdown.style.maxHeight = `${spaceBelow}px`;
                dropdown.style.overflowY = 'auto';

                if (item.classList.contains('mega-element')) {
                    const nav = document.getElementById('desktop_mega_menu');
                    const navRect = nav.getBoundingClientRect();
                    const itemRect = item.getBoundingClientRect();

                    const columns = parseInt(dropdown.querySelector('.submenu_groups').getAttribute('data-columns')) || 1;
                    const columnWidth = 195;
                    const columnGap = 40;
                    const dropdownPadding = 0;

                    const totalWidth = (columns * columnWidth) + ((columns - 1) * columnGap);
                    const spaceToRightEdge = navRect.right - itemRect.left;
                    const finalWidth = Math.min(totalWidth, spaceToRightEdge - dropdownPadding);

                    dropdown.style.left = '0';
                    dropdown.style.right = 'auto';
                    dropdown.style.width = `${finalWidth}px`;
                } else if (item.classList.contains('drawer-element')) {
                    const header = document.querySelector('.header-block-inner');
                    const nav = document.getElementById('desktop_mega_menu');
                    const headerRect = header.getBoundingClientRect();
                    const navRect = nav.getBoundingClientRect();
                    const itemRect = item.getBoundingClientRect();

                    const spaceToLeftEdge = navRect.left - headerRect.left;
                    dropdown.style.left = `-${spaceToLeftEdge}px`;
                }
            }
        };

        const hide = () => {
            hoverTimeout = setTimeout(() => {
                item.classList.remove('show');
                if (currentOpenItem === item) {
                    currentOpenItem = null;
                }
            }, 300); // delay to allow cursor movement
        };

        item.addEventListener('mouseenter', show);
        item.addEventListener('mouseleave', hide);

        if (dropdown) {
            dropdown.addEventListener('mouseenter', () => clearTimeout(hoverTimeout));
            dropdown.addEventListener('mouseleave', hide);
        }

        dropdown_expand_btn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();

                if (item.classList.contains('show')) {
                    hide();
                } else {
                    show();
                }
            }
        });
    });


    const menuButtons = document.querySelectorAll('.drawer-menu-left .drawer-button-wrp');

    menuButtons.forEach(button => {
        button.addEventListener('mouseenter', () => {
            activateMenuPanel(button, 'mouseenter');
        });

        button.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // prevent page scroll on space
                activateMenuPanel(button, 'keydown');
            }
        });
    });

    function activateMenuPanel(button, event_type) {
        const panels = button.parentNode.parentNode.querySelectorAll('.drawer-menu-right .menu-panel');

        menuButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        // Show related panel
        const targetId = button.getAttribute('data-target');
        let activePanel = null;
        panels.forEach(panel => {
            const isActive = panel.id === targetId;
            panel.classList.toggle('active', isActive);
            panel.setAttribute('aria-hidden', !isActive);
            panel.querySelectorAll('.panel-link').forEach(link => {
                link.setAttribute('tabindex', '-1');
            })
            if (isActive) {
                activePanel = panel;
            }
        });

        if (activePanel && event_type == 'keydown') {
            activePanel.querySelectorAll('.panel-link').forEach(link => {
                link.setAttribute('tabindex', '0');
            })
            trapFocusSub(activePanel);
        }
    }

    function trapFocusSub(container) {
        const focusableSelectors = [
            'a[href]', 'area[href]', 'input:not([disabled])',
            'select:not([disabled])', 'textarea:not([disabled])',
            'button:not([disabled])', 'iframe', '[tabindex]:not([tabindex="-1"])',
            '[role="button"]'
        ];
        const focusableElements = Array.from(container.querySelectorAll(focusableSelectors.join(',')))
            .filter(el => el.offsetParent !== null); // only visible elements

        const firstEl = focusableElements[0];
        const lastEl = focusableElements[focusableElements.length - 1];

        container.addEventListener('keydown', function(e) {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    if (document.activeElement === firstEl) {
                        e.preventDefault();
                        lastEl.focus();
                    }
                } else {
                    if (document.activeElement === lastEl) {
                        e.preventDefault();
                        firstEl.focus();
                    }
                }
            } else if (e.key === 'Escape') {
                e.preventDefault();
                window.setTimeout(function() {
                    container.setAttribute('aria-hidden', true);
                    container.parentNode.parentNode.querySelector('.drawer-menu-left .drawer-button-wrp.active').focus();

                    container.querySelectorAll('.panel-link').forEach(link => {
                        link.setAttribute('tabindex', '-1');
                    })
                    return;
                }, 50);
            }
        });

        // Optional: focus the first item when opening
        if (firstEl) firstEl.focus();
    }
}

function floating_dropdown(reference, element) {
    if (reference && element) {
        FloatingUIDOM.computePosition(reference, element, {
            middleware: [FloatingUIDOM.autoPlacement({
                // 'right' and 'left' won't be chosen
                allowedPlacements: ['top', 'bottom'],
            })],
        }).then(({placement}) => {
            element.classList.remove('top', 'bottom');
            element.classList.add(placement);
        });
    }
}

window.currentDropdownTrap = null;
window.trapDropdownFocus = function(dropdownEl) {
    if (window.currentDropdownTrap) {
        document.removeEventListener('keydown', window.currentDropdownTrap);
        window.currentDropdownTrap = null;
    }

    const focusableSelectors = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableEls = [...dropdownEl.querySelectorAll(focusableSelectors)].filter(el =>
        el.offsetParent !== null && !el.disabled
    );

    if (focusableEls.length === 0) return;

    const first = focusableEls[0];
    const last = focusableEls[focusableEls.length - 1];

    window.currentDropdownTrap = function (e) {
        if (e.key !== 'Tab') return;
        const active = document.activeElement;

        if (e.shiftKey && active === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && active === last) {
            e.preventDefault();
            first.focus();
        }
    };

    document.addEventListener('keydown', window.currentDropdownTrap);
}
window.setupDropdownFocusTrap = function(dropdownEl) {
    if (!dropdownEl) return;

    let lastState = false;

    const observer = new MutationObserver(() => {
        const isMobile = get_vw() < screen_md_min;
        const isVisible = dropdownEl.classList.contains('show') || dropdownEl.classList.contains('opened');

        if (isMobile && isVisible && !lastState) {
            window.trapDropdownFocus(dropdownEl);
            lastState = true;
        } else if ((!isVisible || !isMobile) && lastState) {
            if (window.currentDropdownTrap) {
                document.removeEventListener('keydown', window.currentDropdownTrap);
                window.currentDropdownTrap = null;
            }
            lastState = false;
        }
    });

    observer.observe(dropdownEl, { attributes: true, attributeFilter: ['class'] });
}

window.setupModalFocusTrap = function(element) {
    if (!element) return;

    let lastState = false;
    let lastFocusedElement = null;

    const observer = new MutationObserver(() => {
        const isVisible = element.classList.contains('show');

        if (isVisible && !lastState) {
            lastFocusedElement = document.activeElement;
            window.trapDropdownFocus(element);
            lastState = true;
        } else if (!isVisible && lastState) {
            if (window.currentDropdownTrap) {
                document.removeEventListener('keydown', window.currentDropdownTrap);
                window.currentDropdownTrap = null;
            }
            if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
                lastFocusedElement.focus();
            }
            lastState = false;
        }
    });

    observer.observe(element, { attributes: true, attributeFilter: ['class'] });
}
